import type { ReactNode, SVGProps } from 'react'

export interface CustomIconProps {
	title?: string
	size?: number
}

interface IconTemplateProps extends CustomIconProps {
	children: ReactNode
}

export const IconTemplate = (props: SVGProps<SVGSVGElement> & IconTemplateProps) => {
	const { children, title, size, ...otherProps } = props

	const customSize = size || '1em'

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={customSize}
			height={customSize}
			fill="currentColor"
			viewBox="0 0 24 24"
			{...otherProps}>
			<>
				{title ? <title>{title}</title> : null}
				{children}
			</>
		</svg>
	)
}
